import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useLang } from "../../i18n/LanguageContext";
import { Reveal, Overline } from "./Reveal";

export const HeritageSection = () => {
  const { t } = useLang();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [-40, 40]);

  return (
    <section id="heritage" ref={ref} data-testid="heritage-section" className="bg-[#FAF9F6] py-28 lg:py-36 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-16 items-center">
        <Reveal>
          <Overline>{t.heritage.overline}</Overline>
          <h2 className="mt-6 font-serif text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-slate-900">
            {t.heritage.title}
          </h2>
          <p className="mt-5 text-base lg:text-lg text-slate-600 leading-relaxed">{t.heritage.body}</p>

          <div className="mt-12 space-y-0" data-testid="heritage-timeline">
            {t.heritage.timeline.map((item, i) => (
              <div key={i} className="flex gap-6 pb-8 last:pb-0 relative">
                <div className="flex flex-col items-center">
                  <span className="w-2.5 h-2.5 rounded-full bg-emerald-700 mt-1.5 shrink-0" />
                  {i < t.heritage.timeline.length - 1 && <span className="w-px flex-1 bg-slate-300 mt-1" />}
                </div>
                <div>
                  <span className="font-serif text-xl font-bold text-slate-900">{item.year}</span>
                  <p className="mt-1 text-sm text-slate-600 leading-relaxed">{item.text}</p>
                </div>
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="relative">
            <motion.div style={{ y }} className="relative overflow-hidden">
              <img
                src="https://images.unsplash.com/photo-1616778504617-11615e3ceff7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
                alt="Luxembourg City"
                className="w-full h-[420px] lg:h-[540px] object-cover"
                data-testid="heritage-image"
              />
            </motion.div>
            <div className="absolute -bottom-6 -left-6 bg-white border border-slate-200 px-8 py-6 shadow-lg">
              <span className="text-[10px] font-mono uppercase tracking-[0.2em] text-slate-500">{t.heritage.officeLabel}</span>
              <p className="mt-1 font-serif text-lg font-semibold text-slate-900">{t.heritage.officeLine1}</p>
              <p className="text-sm text-slate-500">{t.heritage.officeLine2}</p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
